import {UrlLink} from '../../../applink/UrlLink';
import {t} from '../../../common/getTranslations';
import {twMerge} from '../../../common/twMerge';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';

import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {ViewerNavbarMenu} from '../ViewerNavbarMenu/ViewerNavbarMenu';
import {PcViewerHeaderProps} from './PcViewerHeaderProps.interface';

export function PcViewerHeader({
  isShortsDrama,
  title,
  seriesId,
  productId,
  commentCount,
  hasNavMenu,
  hasBookmarkButton,
  isBookmarkActive,
  isPrevButtonEnabled,
  isNextButtonEnabled,
  isNonstopWatching,
  hasViewTypeButton,
  isScrollView,
  showAgeGradeLabel,
  onClickViewTypeButton,
  onClickContentsHomeButton,
  onClickBookmarkButton,
  onClickNonStopWatchingButton,
  onClickCommentButton,
  onClickPrevButton,
  onClickNextButton,
  prevButtonTiaraObject,
  nextButtonTiaraObject,
  className,
  ...props
}: PcViewerHeaderProps) {
  return (
    <div
      className={twMerge(
        'relative flex h-pc_viewer_header_height_px w-full flex-row items-center justify-between px-30pxr',
        className
      )}
      {...props}
    >
      {showAgeGradeLabel ? (
        <div className="pointer-events-none absolute -bottom-32pxr left-1/2 flex h-20pxr -translate-x-1/2 items-center justify-center rounded-100pxr bg-[rgb(var(--colors-static-mono-black)_/_30%)] px-6pxr">
          <Text className="font-x-small1-bold text-static-mono-white">
            {t('viewer_menu_age', {
              values: {
                value: 15,
              },
            })}
          </Text>
        </div>
      ) : undefined}
      {/* 뷰어 헤더 좌측 영역입니다. */}
      <div className="mr-12pxr flex flex-1 flex-row items-center">
        <UrlLink
          url={seriesId !== undefined ? `/content/${seriesId}` : undefined}
        >
          <Icon
            onClick={e =>
              LOG_CLICK_EVENT('콘텐츠홈_클릭', e, onClickContentsHomeButton)
            }
            className="mr-16pxr cursor-pointer"
            type={IconType.NavigationContentsHome}
          />
        </UrlLink>
        {!!title && (
          <Text className="font-medium1-bold line-clamp-1 text-ellipsis break-all text-theme-solid-100">
            {title}
          </Text>
        )}
      </div>
      {/* 뷰어 헤더 우측 영역입니다. */}
      {hasNavMenu && (
        <div className="flex flex-row items-center">
          {hasBookmarkButton && (
            <Icon
              onClick={onClickBookmarkButton}
              className="mr-35pxr cursor-pointer"
              type={
                isBookmarkActive
                  ? IconType.NavigationBookmarkOnStatic
                  : IconType.NavigationBookmarkOff
              }
            />
          )}
          <ViewerNavbarMenu
            isShortsDrama={isShortsDrama}
            seriesId={seriesId}
            productId={productId}
            commentCount={commentCount}
            isMobile={false}
            hasListButton={false}
            isNonstopWatching={isNonstopWatching}
            hasViewTypeButton={hasViewTypeButton}
            isScrollView={isScrollView}
            isPrevButtonEnabled={isPrevButtonEnabled}
            isNextButtonEnabled={isNextButtonEnabled}
            onClickViewTypeButton={onClickViewTypeButton}
            onClickNonStopWatchingButton={onClickNonStopWatchingButton}
            onClickCommentButton={onClickCommentButton}
            onClickPrevButton={onClickPrevButton}
            onClickNextButton={onClickNextButton}
            prevButtonTiaraObject={prevButtonTiaraObject}
            nextButtonTiaraObject={nextButtonTiaraObject}
          />
        </div>
      )}
    </div>
  );
}
